import React, { useContext, useEffect } from 'react'
// import './App.css';


import { Routes, Route, useNavigate, useLocation } from "react-router-dom";


import { Auth } from './Contexts/AuthContext';
import PageNotFound from './Components/comman/PageNotFound';
import MyCampaigns from './Components/Brands/Campaign';
import TaskRequests from './Components/Brands/TaskRequests';
import MyPayouts from './Components/Infulencer/MyPayouts';
import ForgotBrandHome from './Components/Brands/forgotPassword/ForgotBrandHome';
import ForgotInfulencerHome from './Components/Infulencer/forgotInfulencerPassword/ForgotInfulencerHome';
import ResetBrandPassword from './Components/Brands/forgotPassword/ResetBrandPassword';
import ResetInfulencerPassword from './Components/Infulencer/forgotInfulencerPassword/ResetInfulencerPassword';
import JoinPage from './Components/comman/JoinPage';
import BrandJoin from './Components/Brands/brandSignUp/BrandJoin';
import InfluencerJoin from './Components/Infulencer/infulencerSignUp/InfluencerJoin';
import MyPosts from './Components/Infulencer/MyPosts';
import ConnectSocialPlatform from './Components/Infulencer/infulencerSignUp/ConnectSocialPlatform';
import Terms from './Components/comman/Terms';
import PrivacyPolicy from './Components/comman/PrivacyPolicy';
import Profile from './Components/Profile';
import AllTasks from './Components/Brands/AllTasks';
import InfluencerLogin from './Pages/login/InfluencerLogin';
import BrandLogin from './Pages/login/BrandLogin';
import ForgotPassword from './Pages/login/ForgotPassword';
import InfluencerDashboard from './Pages/InfluencerDashboard';
import ContactUs from './Pages/ContactUs';
import CollaborationHub from './Pages/CollaborationHub/CollaborationHub';
import ProductDetails from './Pages/ProductsDetails/ProductDetails';

import BrandDashboard from './Pages/Brand/Dashboard';
import AnalyticsHome from './Pages/Brand/Analytics';
import BrandAccount from './Pages/Brand/Account';
import BrandInbox from './Pages/Brand/Inbox';
import CreateCampagin from './Pages/Brand/Campaigns/CreateCampagin';
import CampaginHome from './Pages/Brand/Campaigns';
import Campagin from './Pages/InfluencerDashboard/Campagin';
import Wishlist from './Pages/InfluencerDashboard/Wishlist';
import Account from './Pages/InfluencerDashboard/Account';
import Wallet from './Pages/InfluencerDashboard/WalletDetails';
import EditCampign from './Pages/Brand/Campaigns/EditCampaign';



const App = () => {

  const { auth } = useContext(Auth);

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // console.log(auth);
    if (auth?.token && auth?.userRole === "BRAND" && location.pathname === "/") {
      navigate('/brand/dashboard');
    }
    if (auth?.token && auth?.userRole === "INFLUENCER" && location.pathname === "/") {
      navigate('/influencer/dashboard');
    }
  }, [location])




  return (
    
  
      <Routes >
        
      
        
        <Route exact path="/" element={<InfluencerLogin />}></Route>
        <Route exact path="/campagin-detail" element={<ProductDetails />}></Route>
        <Route exact path="/collaboration-hub" element={<CollaborationHub />}></Route>
        <Route exact path="/contact-us" element={<ContactUs/>}></Route>
        <Route exact path="/brand" element={<BrandLogin />}></Route>
        <Route exact path="/forgot-password" element={<ForgotPassword />}></Route>
        <Route exact path="/brand/forgot-password" element={<ForgotBrandHome />}></Route>
        <Route exact path="/influencer/forgot-password" element={<ForgotInfulencerHome />}></Route>
        <Route exact path="/brand/reset-password" element={<ResetBrandPassword />}></Route>
        <Route exact path="/infulencer/reset-password" element={<ResetInfulencerPassword />}></Route>
        <Route exact path="/join-dreamstar" element={<JoinPage />}></Route>
        <Route exact path="/brand-signin" element={<BrandJoin />}></Route>
        <Route exact path="/influencer-signin" element={<InfluencerJoin />}></Route>
        <Route exact path="/connect-platform" element={<ConnectSocialPlatform />}></Route>
        {auth?.token && (
          <>
            {auth?.userRole === "BRAND" && (
              <>
                <Route exact path="/brand/dashboard" element={<BrandDashboard />}></Route>
                <Route exact path="/brand/campaigns" element={<CampaginHome />}></Route>
                <Route exact path="/brand/campaign/:id" element={<CreateCampagin />}></Route>
                <Route exact path="/brand/edit-campaign/:campaign_title" element={<EditCampign />}></Route>
                <Route exact path="/brand/analytics" element={<AnalyticsHome />}></Route>
                <Route exact path="/brand/inbox" element={<BrandInbox />}></Route>
                <Route exact path="/brand/account" element={<BrandAccount />}></Route>
                <Route exact path="/my-campaigns" element={<MyCampaigns />}></Route>
                <Route exact path="/tasks-requests/:id" element={<TaskRequests />}></Route>
                <Route exact path="/tasks" element={<AllTasks />}></Route>
                <Route exact path="/profile" element={<Profile />}></Route>
              </>
            )}
            {auth?.userRole === "INFLUENCER" && (
              <>
                <Route exact path="/influencer/dashboard" element={<InfluencerDashboard />}></Route>
                <Route exact path="/influencer/campaigns" element={<Campagin />}></Route>
                <Route exact path="/influencer/wishlist" element={<Wishlist />}></Route>
                <Route exact path="/influencer/account" element={<Account />}></Route>
                <Route exact path="/my-posts" element={<MyPosts />}></Route>
                <Route exact path="/my-payouts" element={<MyPayouts />}></Route>
                <Route exact path="/profile" element={<Profile />}></Route>
                <Route exact path="/walletDetails" element={<Wallet />}></Route>
              </>
            )}
           

          </>
        )}
        <Route exact path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route exact path="/terms" element={<Terms/>} />
       
        <Route path="*" element={<PageNotFound />} />




      </Routes>

    
  )
}

export default App
